import { useMutation } from 'react-query'
import { impactsLibraryService } from 'src/services'
import { IImpactLibrarySuggestDto } from 'src/types'

export const useLibraryImpactSuggestion = () => {
  return useMutation((dto: IImpactLibrarySuggestDto) =>
    impactsLibraryService.suggestLibraryImpact(dto),
  )
}
